import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import global from "@/common/global"
import 'vant/lib/index.css'
import "./assets/font/font.css"
import * as filters from './filters' // 全局filter
import api from './common/api.js'
import 'animate.css'
Vue.use(Vant)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
window.gg = {}
window.gg.router = router
Vue.prototype.$api = api
Vue.prototype.$global = global

// router.beforeEach((to, from, next) => {
//   document.title = ''
//   next()
// })

// router.afterEach((to, from) => {
//   document.title = to.meta.title
// })

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js